import { ComponentRef, Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { InputObservable } from '@y42/angular/util';
import { StopPropagationDirective } from '@y42/core/stop-propagation';
import { Observable, tap } from 'rxjs';
import { IJobInfoComponent } from '../../api';
import { JobQuery, JobUIModel } from '../../state';
import { JobInfoComponent } from './job-info.component';

@UntilDestroy()
@Directive({
  selector: '[y42JobInfoHost][jobIds]',
})
export class JobInfoHostDirective extends StopPropagationDirective implements OnInit {
  constructor(private readonly viewContainerRef: ViewContainerRef, private readonly jobQuery: JobQuery) {
    super();
  }

  @Input()
  @InputObservable()
  jobIds: Array<JobUIModel['request_id']> = [];
  private readonly jobIds$!: Observable<Array<JobUIModel['request_id']>>;
  private componentRef?: ComponentRef<IJobInfoComponent>;

  @Input()
  showLogsButton = true;

  ngOnInit(): void {
    this.jobIds$
      .pipe(
        tap((jobIds) => {
          const componentRef = this.componentRef;
          if (componentRef) {
            this.setJobDisplayComponentProperties(componentRef, jobIds);
          } else {
            this.renderJobDisplayComponent(jobIds);
          }
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  private renderJobDisplayComponent(jobs: Array<JobUIModel['request_id']>) {
    this.viewContainerRef.clear();
    if (jobs.length === 0) {
      return;
    }

    const componentRef = this.viewContainerRef.createComponent(JobInfoComponent);
    this.componentRef = componentRef;
    this.setJobDisplayComponentProperties(componentRef, jobs);
  }

  private setJobDisplayComponentProperties(
    componentRef: ComponentRef<IJobInfoComponent>,
    jobIds: Array<JobUIModel['request_id']>,
  ) {
    if (jobIds.length === 0) {
      return;
    }

    const componentProperties: IJobInfoComponent = {
      jobIds,
      showLogsButton: this.showLogsButton,
    };
    Object.entries(componentProperties).forEach(
      ([property, value]) => (componentRef.instance[property as keyof IJobInfoComponent] = value),
    );
  }
}
